import { OPERATORS } from '@shared/types/dynamic-filter';
import { FIELD_TYPES } from '@shared/types/field';

export const OPERATOR_LABEL_MAPPER = {
  [OPERATORS.equal]: 'Is',
  [OPERATORS.notEqual]: 'Is not',
  [OPERATORS.greaterThan]: 'Greater than',
  [OPERATORS.greaterThanEqual]: 'Greater than or equal',
  [OPERATORS.lessThan]: 'Less than',
  [OPERATORS.lessThanEqual]: 'Less than or equal',
  [OPERATORS.in]: 'In',
  [OPERATORS.notIn]: 'Not In',
  [OPERATORS.contains]: 'Contain',
  [OPERATORS.notContains]: 'Not Contain',
};

export const OPERATORS_ACC_TO_FILTER_TYPE = {
  [FIELD_TYPES.shortAnswer]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.contains,
    OPERATORS.notContains,
  ],
  [FIELD_TYPES.paragraph]: [OPERATORS.contains, OPERATORS.notContains],
  [FIELD_TYPES.checklist]: [OPERATORS.in, OPERATORS.notIn],
  [FIELD_TYPES.dropdown]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.contains,
    OPERATORS.notContains,
  ],
  [FIELD_TYPES.email]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.contains,
    OPERATORS.notContains,
  ],
  [FIELD_TYPES.date]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.greaterThan,
    OPERATORS.greaterThanEqual,
    OPERATORS.lessThan,
    OPERATORS.lessThanEqual,
  ],
  [FIELD_TYPES.dateTime]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.greaterThan,
    OPERATORS.greaterThanEqual,
    OPERATORS.lessThan,
    OPERATORS.lessThanEqual,
  ],
  [FIELD_TYPES.phoneNumber]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.contains,
    OPERATORS.notContains,
  ],
  [FIELD_TYPES.country]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.in,
    OPERATORS.notIn,
  ],
  [FIELD_TYPES.countryMultiselect]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.in,
    OPERATORS.notIn,
  ],
  [FIELD_TYPES.number]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.greaterThan,
    OPERATORS.greaterThanEqual,
    OPERATORS.lessThan,
    OPERATORS.lessThanEqual,
  ],
  [FIELD_TYPES.ratio]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.in,
    OPERATORS.notIn,
  ],
  [FIELD_TYPES.link]: [
    OPERATORS.equal,
    OPERATORS.notEqual,
    OPERATORS.contains,
    OPERATORS.notContains,
  ],
};

export const STATIC_FILTER_ENTITY_TYPES = {
  member: 'MEMBER',
  leadReferal: 'LEAD_REFERAL',
  leadStatus: 'LEAD_STATUS',
  leadSource: 'LEAD_SOURCE',
  label: 'LABEL',
  program: 'PROGRAM',
  partner: 'PARTNER',
  stage: 'STAGE',
  date: 'DATE',
} as const;
